export enum Category {
  Custom = "Custom",
  System = "System",
  Default = "Default",
  Template = "Template"
}
